// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2eSFV","box":"WorkspacesBox_box__3W_hw","node":"WorkspacesBox_node__2QZp-"};